import $ from 'jquery';

const defaults = {
  showVideoAtThisBreakpoint: 720,
  playBtn: '<button class="slick-play slick-btn" type="button" aria-label="Play">Play</button>',
  pauseBtn: '<button class="slick-pause slick-btn" type="button" aria-label="Pause">Pause</button>',
};

function Video(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.video = null;
  this.playing = false;
  this.playPause = this.playPause.bind(this);
  this.$playBtn = this.addPlayBtn();
  this.$pauseBtn = this.addPauseBtn();
  this.$bgVideo = this.getVideo();
  this.$destination = this.getDestination();
  this.init();
}

Video.prototype = {
  init() {
    // if the background element or image isn't found, quit.
    if (!this.$bgVideo.length || !this.$destination) return;
    // show if applicable
    if ($(window).width() >= this.settings.showVideoAtThisBreakpoint && !this.isMobileDevice()) {
      this.addVideo();
    }
  },
  isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  },
  getVideo() {
    return this.$element.find('.background-video');
  },
  getDestination() {
    return this.$element.find('.field-image.c1 img');
  },
  addPlayBtn() {
    return $(this.settings.playBtn);
  },
  addPauseBtn() {
    return $(this.settings.pauseBtn);
  },
  addVideo() {
    const $source = this.$bgVideo.find('.video');
    const sources = $source.data('src').replace(/\s/g, '').split(',');
    const $video = $('<video autoplay loop muted></video>');

    // Assign the video element so we can use it.
    this.video = $video[0];

    $.each(sources, (i, src) => {
      const type = src.substring(src.lastIndexOf('.') + 1);
      $video.append(`<source src="${src}" type="video/${type}">`);
    });

    this.$destination.replaceWith($video);

    // Fired when the browser has finished loading the metadata for the video
    // and all attributes have been populated.
    $video.bind('loadeddata', () => {
      this.$element.addClass('ready');
      this.addControls();
    });

    // Fired when the video starts playing, for the first time, after being paused
    // or when restarting.
    $video.bind('playing', () => {
      this.playing = true;
      this.setCurrentState();
    });

    // Add a helper class to possibly style this block differently if a video is present.
    this.$element.addClass('has-background-video');

    // Delete temp markup
    this.$bgVideo.remove();
  },
  addControls() {
    // Add play and pause the controls and finally add the controls container
    this.$element.append(this.$playBtn, this.$pauseBtn);

    // Add click handlers to each button to control autoplay functionality
    this.$playBtn.on('click', this.playPause);
    this.$pauseBtn.on('click', this.playPause);
  },
  playPause() {
    if (this.playing) {
      this.video.pause();
      this.playing = false;
    } else {
      this.video.play();
      this.playing = true;
    }
    this.setCurrentState();
  },
  setPlayState() {
    this.$playBtn.attr('aria-hidden', 'false');
    this.$pauseBtn.attr('aria-hidden', 'true');
  },
  setPauseState() {
    this.$playBtn.attr('aria-hidden', 'true');
    this.$pauseBtn.attr('aria-hidden', 'false');
  },
  setCurrentState() {
    if (this.playing) {
      this.setPauseState();
    } else {
      this.setPlayState();
    }
  },
};

export default Video;



// WEBPACK FOOTER //
// ./Video.js